import { render } from "./CardProductHomeComp.vue?vue&type=template&id=2830be68&scoped=true"
import script from "./CardProductHomeComp.vue?vue&type=script&lang=js"
export * from "./CardProductHomeComp.vue?vue&type=script&lang=js"

import "./CardProductHomeComp.vue?vue&type=style&index=0&id=2830be68&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\LENOVO\\Documents\\workspace\\tulumoutdoor_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2830be68"]])

export default __exports__